// src/api/stylesAccessApi.js
// Cliente de la puerta de acceso al editor de estilos (OTP por correo).
import { ENV } from "../Utils";

export class StylesAccessApi {
  baseApi = ENV.BASE_API;

  async sendOtp(token, email) {
    const res = await fetch(`${this.baseApi}/style-access/send-otp`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    const json = await res.json();
    if (res.status !== 200) throw json;
    return json.data; // { styleOtpToken }
  }

  async verifyOtp(token, styleOtpToken, code) {
    const res = await fetch(`${this.baseApi}/style-access/verify-otp`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ styleOtpToken, code }),
    });
    const json = await res.json();
    if (res.status !== 200) throw json;
    return json.data; // { grant, email, isApprover }
  }

  async resendOtp(token, styleOtpToken) {
    const res = await fetch(`${this.baseApi}/style-access/resend-otp`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ styleOtpToken }),
    });
    const json = await res.json();
    if (res.status !== 200) throw json;
    return json;
  }
}

export default StylesAccessApi;
